import script from "./MealTypeFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./MealTypeFilter.vue?vue&type=script&setup=true&lang=js"

import "./MealTypeFilter.vue?vue&type=style&index=0&id=7f88d718&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f88d718"]])

export default __exports__